<template>
	<div class="bg">
		<div class="search-container">
			<div style="font-size: 16px; font-weight: bold; padding-bottom: 16px;">店铺数据</div>

			<!-- 筛选区域 -->
			<div class="search-form">
				<div class="input-wrapper">
					<label class="input-label">时间维度：</label>
					<el-radio-group v-model="searchParams.timeDimension" @change="handleTimeDimensionChange">
						<el-radio :label="1">日</el-radio>
						<el-radio :label="2">月</el-radio>
						<el-radio :label="3">年</el-radio>
					</el-radio-group>
				</div>
				<div class="input-wrapper">
					<label class="input-label">查询日期：</label>
					<el-date-picker v-model="searchParams.queryDate" :type="datePickerType" :value-format="datePickerValueFormat"
						:placeholder="datePickerPlaceholder" clearable style="width: 100%; background-color: #F2F3F5;">
					</el-date-picker>
				</div>

				<div class="divider"></div>
				<div class="search flexc" style="cursor: pointer;" @click="handleSearch">
					<img src="/images/goodsList/search.svg" width="14px" height="14px" alt="" />
					<div style="margin-left: 4px; font-size: 14px;">查询</div>
				</div>
				<div class="reset flexc" style="cursor: pointer;" @click="handleReset">
					<div style="margin-left: 4px; font-size: 14px;">重置</div>
				</div>
			</div>
		</div>

		<div style="margin-top: 20px;">
			<el-table ref="etb2" class="custom-header-table" :height="tblHeight" v-loading="tableLoading"
				:data="fullList">
				<el-table-column type="index" label="序号" width="70" align="center" :index="getTableIndex">
				</el-table-column>
				<el-table-column label="日期" width="140" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.dataTime || '--' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="浏览量（次）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.browseCount) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="订单量（单）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.orderNum) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="订单总额（元）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatAmount(getOrderTotalAmount(scope.row)) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="取消订单量（单）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.refundNum) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="取消订单总额（元）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatAmount(scope.row.refundAmount) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="到店订单量（单）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.onSiteNum) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="到店订单额（元）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatAmount(scope.row.onSiteAmount) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="配送订单量（单）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatValue(scope.row.takeoutNum) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="配送订单额（元）" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatAmount(scope.row.takeoutAmount) }}</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="flexs" style="margin-top: 12px;">
				<div class="down flexc" style="margin-left: 20px; cursor: pointer;" @click="handleExport">
					<i class="el-icon-folder-add" style="padding-right: 4px;"></i>
					导出
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		operationStatisticApi
	} from '@/api';
	import {
		exportTableToExcel
	} from '@/utils/exportExcel';

	export default {
		name: 'ShopDate',
		data() {
			return {
				tableLoading: false,
				tblHeight: null,
				searchParams: {
					timeDimension: 1,
					queryDate: ''
				},
				fullList: []
			};
		},
		created() {
			this.fetchList();
		},
		computed: {
			datePickerType() {
				return this.searchParams.timeDimension === 1 ? 'month' : 'year';
			},
			datePickerValueFormat() {
				return this.searchParams.timeDimension === 1 ? 'yyyy-MM' : 'yyyy';
			},
			datePickerPlaceholder() {
				return this.searchParams.timeDimension === 1 ? '请选择月份' : '请选择年份';
			}
		},
		methods: {
			handleTimeDimensionChange() {
				this.searchParams.queryDate = '';
			},
			formatQueryDateForRequest() {
				const {
					timeDimension,
					queryDate
				} = this.searchParams;
				if (!queryDate) {
					return '';
				}
				if (timeDimension === 1 && /^\d{4}-\d{2}$/.test(queryDate)) {
					return `${queryDate}-01`;
				}
				if ((timeDimension === 2 || timeDimension === 3) && /^\d{4}$/.test(queryDate)) {
					return `${queryDate}-01-01`;
				}
				return queryDate;
			},
			getStoreId() {
				return this.$store.getters['auth/storeId'];
			},
			buildRequestParams() {
				const params = {
					// 该接口返回的数据量一般很小（日<=31、月<=12、年<=5），这里一次取全
					pageNo: 1,
					pageSize: 999,
					timeDimension: this.searchParams.timeDimension
				};
				const queryDate = this.formatQueryDateForRequest();
				if (queryDate) {
					params.queryDate = queryDate;
				}
				const storeId = this.getStoreId();
				if (storeId) {
					params.storeId = storeId;
				}
				return params;
			},
			async fetchList() {
				this.tableLoading = true;
				try {
					const response = await operationStatisticApi.orderList(this.buildRequestParams());
					if ((response.code === 0 || response.code === 200) && response.data) {
						this.fullList = Array.isArray(response.data) ? response.data : [];
					} else {
						this.fullList = [];
						this.$message.error(response.msg || '获取店铺数据失败');
					}
				} catch (err) {
					console.error('获取店铺数据错误:', err);
					this.fullList = [];
					this.$message.error('网络异常，无法获取店铺数据');
				} finally {
					this.tableLoading = false;
				}
			},
			handleSearch() {
				this.fetchList();
			},
			handleReset() {
				this.searchParams = {
					timeDimension: 1,
					queryDate: ''
				};
				this.fetchList();
			},
			getTableIndex(index) {
				return index + 1;
			},
			formatValue(value) {
				if (value === 0) {
					return 0;
				}
				return value || '--';
			},
			formatAmount(value) {
				if (value === 0) {
					return 0;
				}
				if (value === null || value === undefined || value === '') {
					return '--';
				}
				return value;
			},
			getOrderTotalAmount(row) {
				if (!row) {
					return null;
				}
				if (row.payAmount !== undefined && row.payAmount !== null && row.payAmount !== '') {
					return row.payAmount;
				}
				const onSite = row.onSiteAmount || 0;
				const takeout = row.takeoutAmount || 0;
				const total = onSite + takeout;
				return total || null;
			},
			handleExport() {
				const columns = [{
						label: '序号',
						prop: '__index'
					},
					{
						label: '日期',
						prop: 'dataTime'
					},
					{
						label: '浏览量（次）',
						prop: 'browseCount'
					},
					{
						label: '订单量（单）',
						prop: 'orderNum'
					},
					{
						label: '订单总额（元）',
						prop: 'payAmount'
					},
					{
						label: '取消订单量（单）',
						prop: 'refundNum'
					},
					{
						label: '取消订单总额（元）',
						prop: 'refundAmount'
					},
					{
						label: '到店订单量（单）',
						prop: 'onSiteNum'
					},
					{
						label: '到店订单额（元）',
						prop: 'onSiteAmount'
					},
					{
						label: '配送订单量（单）',
						prop: 'takeoutNum'
					},
					{
						label: '配送订单额（元）',
						prop: 'takeoutAmount'
					}
				];

				const rows = (this.fullList || []).map((item, idx) => ({
					...item,
					__index: idx + 1,
					payAmount: this.getOrderTotalAmount(item)
				}));

				exportTableToExcel({
					fileName: '店铺数据.xls',
					columns,
					rows
				});
			}
		}
	};
</script>
